import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsParkingLotModel {
  id: string;
  location: string;
  carCapacity: string;
  motorcycleCapacity: string;
  bicycleCapacity: string;
  busCapacity: string;
  startHourWeek: string;
  endHourWeek: string;
  startHourSaturday: string;
  endHourSaturday: string;
  startHourSunday: string;
  endHourSunday: string;
  operator: string;
  title: string;
  markerPopupText: string;
  icon: Icon;
}

export class ParkingLotModel extends MarkerModelBase {
  static className = 'ParkingLotModel';
  classProperties: IPropsParkingLotModel;

  constructor(
    props: IPropsParkingLotModel,
    geometry: IGeometryModel,
    lat?: number,
    lng?: number
  ) {
    super(geometry, ParkingLotModel.className, lat, lng);
    this.classProperties = props;

    this.geometry = geometry;
  }
}
